/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */

/**
 * classNames
 * @param  {...any} classes
 * @returns
 */
export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default classNames;
